import sanitizePhoneNumber from '../sanitizePhoneNumber';

export const validatePhoneNumber = (phoneNumber: string | undefined) => {
  if (!phoneNumber) return false;
  const re = /^[0-9]+$/;
  const sanitizedPhoneNumber = sanitizePhoneNumber(phoneNumber);

  return Boolean(sanitizedPhoneNumber.length === 10 && re.test(sanitizedPhoneNumber));
};
